import React, { useEffect, useState } from 'react';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { Link } from '@uhg-abyss/web/ui/Link';
import { styled } from '@uhg-abyss/web/tools/styled';

const Wrapper = styled('div', {
  paddingLeft: '24px',
  hyphens: 'auto',
});

const Heading = styled('div', {
  color: '#5a5a5a',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '16px',
  textAlign: 'left',
  textTransform: 'uppercase',
  margin: '8px 0px',
});

const StyledLink = styled(Link, {
  textAlign: 'left',
  marginBottom: '8px',
  display: 'block',
  fontSize: '15px ! important',
  fontWeight: '400 ! important',
});

export const OnThisPage = () => {
  const [headings, setHeadings] = useState([]);
  const { resource } = useParams();

  const getSubheaderView = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Combine the useEffects with enhanced timing strategies
  // This will run on initial mount and when resource changes // This will run on initial mount and when resource changes
  useEffect(() => {
    // Define a clean implementation for getting headings
    const getHeadingsWithCheck = () => {
      // Only proceed if there are no headings yet or if we're refreshing based on resource change
      requestAnimationFrame(() => {
        // Target only H2 elements within the main content area
        const contentArea =
          document.querySelector('.content-area') ||
          document.querySelector('main') ||
          document;

        // Get only visible H2 elements with IDs that are part of the main content
        const elements = Array.from(contentArea.querySelectorAll('h2'))
          .filter((element) => {
            // Ensure element has ID and is visible
            return (
              element.id &&
              !element.classList.contains('hidden') &&
              getComputedStyle(element).display !== 'none' &&
              element.offsetParent !== null
            );
          })
          .map((element) => {
            return {
              id: element.id,
              text: element.textContent?.trim() ?? '',
            };
          });

        // Only update state if we found elements or we need to clear the previous list
        if (elements.length > 0 || headings.length > 0) {
          //  console.log('Found headings:', elements);
          setHeadings(elements);
        }
      });
    };

    // Set up a mutation observer to watch for content changes
    const observer = new MutationObserver((mutations) => {
      getHeadingsWithCheck();
    });

    // Initial attempt to get headings
    getHeadingsWithCheck();

    // Start observing the document body for content changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'id'],
    });

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, [resource, headings.length]); // Include headings.length to avoid unnecessary checks

  return (
    <Wrapper>
      <Heading>ON THIS PAGE</Heading>
      {headings.map((topic) => {
        return (
          <React.Fragment key={topic.id}>
            <StyledLink
              size="$md"
              onClick={() => {
                return getSubheaderView(topic.id);
              }}
            >
              {topic.text}
            </StyledLink>
            <br />
          </React.Fragment>
        );
      })}
    </Wrapper>
  );
};
